import React from "react"
import { Card, CardBody } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"

const ShipmentListComponent = ({
  data,
  loading,
  onClickDelete,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onExportBtnClick,
  exportStatus,
}) => {
  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={loading}
          title={"List"}
          rowCount={true}
          onChangeRowNumber={onChangeRowNumber}
          orderingList={true}
          onChangeOrdering={onChangeOrdering}
          searchBox={true}
          onSearchHandler={onSearch}
          exportBtn={true}
          onExportBtnClick={onExportBtnClick}
          exportBtnLoading={exportStatus?.loading}
          rightBtn={true}
          rightBtnTitle={"Add Shipment"}
          rightBtnRoute={"/add-shipment"}
          orderingOptions={[
            { value: "id", name: "ID" },
            { value: "name", name: "Name" },
            { value: "status", name: "Status" },
          ]}
        />

        <GeneralTables
          data={data?.data}
          loading={loading}
          headers={["#", "Name", "Status", "Action"]}
          pagination={{ meta: data?.meta, onPageClick: onPageClick }}
          renderItem={(record, index) => (
            <tr key={record.id}>
              <th scope="row">{data?.meta?.from + index}</th>
              <td>{record.name}</td>
              <td>{record.status}</td>
              <td>
                <ActionColumns
                  data={record}
                  enableEdit={true}
                  enableDelete={true}
                  editRoute={`/edit-shipment/${record.id}`}
                  onClickDelete={onClickDelete}
                />
              </td>
            </tr>
          )}
        />
      </CardBody>
    </Card>
  )
}

export default ShipmentListComponent
